var React = require('react');

function Failed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 0H8C6.9 0 6 0.9 6 2V12C6 12.55 6.22 13.05 6.58 13.41L13.17 20L14.23 18.95C14.5 18.68 14.67 18.3 14.67 17.89L14.64 17.57L13.69 13H20C21.1 13 22 12.1 22 11V9C22 8.74 21.95 8.5 21.86 8.27L18.84 1.22C18.54 0.5 17.83 0 17 0Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M4 12H0V0H4V12Z","fill":"currentColor","key":1})]);
}

Failed.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = Failed;

Failed.default = Failed;
